import { useState } from "react";
import { Outlet } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";
import Aside from "./Aside";
import RightPanel from "./RightPanel";
import CanvasContainer from "../features/canvas/CanvasContainer";
// import UserMenu from "../features/navigation/UserMenu";
// import TopBar from "../features/navigation/TopBar";
import classNames from "classnames";
import { useSelector } from "react-redux";
import { selectIsOpen } from "../app/modalSlice";
import {
  selectIsRightPanelOpen,
  selectIsRightPanelExpanded,
  selectRightPanelContent,
} from "../app/rightPanelSlice";
import styles from "./layout.module.css";
import { resetError, selectError } from "../features/alerts/alertsSlice";
import { AlertModal } from "./Modal";
import { useDispatch } from "react-redux";
import { ErrorMessage } from "./Paragraph";
import useLang from "../hooks/useLang";
import Breadcrumbs from "./Breadcrumbs";
/*         <TopBar /> */

const Layout = () => {
  const [sideNavExpanded, setSideNavExpanded] = useState(true);
  const modalOpen = useSelector(selectIsOpen);
  const rightPanelOpen = useSelector(selectIsRightPanelOpen);
  const rightPanelExpanded = useSelector(selectIsRightPanelExpanded);
  const rightPanelContent = useSelector(selectRightPanelContent);
  const error = useSelector(selectError);
  const dispatch = useDispatch();
  const lang = useLang();

  return (
    <>
      {/*
      <Aside
        expanded={sideNavExpanded}
        onToggle={() => {
          setSideNavExpanded((state) => !state);
        }}
      />
            <div
        className={classNames(styles.app, {
          [styles.sideNavExpanded]: sideNavExpanded,
          [styles.sideNavCollapsed]: !sideNavExpanded,
          [styles.modalOpen]: modalOpen,
        })}
      >
      */}

      <Aside
        expanded={sideNavExpanded}
        onToggle={() => {
          setSideNavExpanded((state) => !state);
        }}
      />
      <div
        className={classNames(styles.app, {
          [styles.modalOpen]: modalOpen,
          [styles.rightPanelExpanded]: rightPanelOpen && rightPanelExpanded,
          [styles.rightPanelCollapsed]: rightPanelOpen && !rightPanelExpanded,
        })}
      >
        <Breadcrumbs />
        <ErrorBoundary fallback="Error in content">
          <div className={styles.appContainer}>
            <Outlet />
          </div>
        </ErrorBoundary>
        <AlertModal
          isOpen={error != null}
          onClose={() => {
            dispatch(resetError());
          }}
          title={lang("captions.error")}
        >
          <ErrorMessage>{error?.message}</ErrorMessage>
        </AlertModal>
      </div>
      {rightPanelOpen && rightPanelContent.toLowerCase() === "canvas" ? (
        <RightPanel>
          <CanvasContainer />
        </RightPanel>
      ) : null}
    </>
  );
};

export default Layout;
